exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modulelayout[data-v-6f8a3186]{grid-template-areas:\"main\" \"sidebar\"}@media screen and (min-width:978px){.modulelayout[data-v-6f8a3186]{grid-template-areas:\"sidebar main\"}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f8a3186","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/parts/modules/modulelayout/ModuleLayout.vue
// module id = dd847fb07feff047e81b
// module chunks = 0